import { IDurationState } from '../types';

export function selectDuration(state: IDurationState, selectedDuration: number): IDurationState {
  return {
    defaultDuration: selectedDuration,
    durations: state.durations.map(duration => ({
      ...duration,
      selected: duration.durationInDays === selectedDuration,
    })),
  };
}
